import { radioField } from '../../../utils/field-config-helpers';

export const amenitiesFieldsConfig = {
  disableFriendly: radioField(),
  anesthesia: radioField(),
};

export type AmenitiesFieldsConfigTypes = typeof amenitiesFieldsConfig;
